export const TopicType = Object.freeze({
  AB: 10,
  POLL: 20,
  TALK: 21,
  CHAT: 22,
});

export const TopicTypeOptions = Object.freeze([
  {
    value: null,
    label: "전체",
  },
  {
    value: TopicType.AB,
    label: "A/B",
  },
  {
    value: TopicType.POLL,
    label: "Poll",
  },
  {
    value: TopicType.TALK,
    label: "Talk",
  },
  {
    value: TopicType.CHAT,
    label: "잡담",
  },
]);

export const TopicTalkType = Object.freeze({
  QA: "QA",
  COMMUNICATION: "COMMUNICATION",
  NOTE: "NOTE",
  REQUEST: "REQUEST",
  STORY: "STORY",
});

export const TopicTalkTypeOptions = Object.freeze([
  {
    value: null,
    label: "전체",
  },
  {
    value: TopicTalkType.QA,
    label: "Q&A",
  },
  {
    value: TopicTalkType.COMMUNICATION,
    label: "소통",
  },
  {
    value: TopicTalkType.NOTE,
    label: "후기,인증",
  },
  {
    value: TopicTalkType.REQUEST,
    label: "요청",
  },
  {
    value: TopicTalkType.STORY,
    label: "입덕썰",
  },
]);
